import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";
import S from "../Allocation/Allocation.styled";

const FondFactsWrapper = styled(MainInner)`
    padding: 0;
    padding-left: 10px;

    @media (max-width: 768px) {
        padding: 0;
    }

    canvas {
        max-height: 400px;

        @media (max-width: 768px) {
            max-height: none;
        }
    }

    #growthGraphContainer {
        height: 40vh;
    }
`;

const FondFactsContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 30px;
`;

const FondFactsItem = styled.div`
    width: 100%;
    margin-bottom: 6px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    padding: 7px 5px;
`;

const FondFactsKey = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.breadText};
    font-family: "Open Sans", sans-serif;
`;

const FondFactsValue = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.breadText};
    font-family: "Open Sans", sans-serif;
`;

const DateSettingsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    overflow: auto;
    padding: 0 10px;
    position: relative;

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    // Add so that it fades out on the right side
    &:before {
        pointer-events: none;
        content: "";
        position: absolute;
        width: 50px;
        height: 100%;
        background: linear-gradient(
            to left,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        top: 0;
        right: 0;
        z-index: 2;
    }
`;

const DateSetting = styled.div<{ isActive: boolean }>`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.breadText};
    font-family: "Open Sans", sans-serif;
    cursor: pointer;
    flex: 1;
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid ${({ theme }) => theme.colors.stroke};
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    transition: 0.2s;
    display: flex;
    gap: 5px;
    align-items: center;
    min-width: 150px;

    @media (max-width: 768px) {
        min-width: 100px;
    }

    &:hover {
        border-bottom: 3px solid ${({ theme }) => theme.colors.primary};    
    }

    ${({ isActive, theme }) => isActive && `
        border-bottom: 3px solid ${theme.colors.primary};
        font-weight: 600;
    `}

    span {
        color: ${({ theme }) => theme.colors.primary};
        font-size: 12px;
    }
`;

const CustomDateSettingsWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 20px;
    input {
        width: 150px;
        padding: 10px;
        border: 1px solid ${({ theme }) => theme.colors.stroke};
        font-size: 14px;
        color: ${({ theme }) => theme.colors.breadText};
        font-family: "Open Sans", sans-serif;
    }
`;

const CustomDateSettingInput = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
        color: ${({ theme }) => theme.colors.title};
        font-family: "Open Sans";
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 18px */
    }
`;

const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vw;
    margin-top: 20px;
`;

const Spinner = styled.div`
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left: 4px solid darkblue;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
`;

const theStyles = {
    FondFactsWrapper,
    FondFactsContent,
    FondFactsItem,
    FondFactsKey,
    FondFactsValue,
    DateSettingsWrapper,
    DateSetting,
    CustomDateSettingsWrapper,
    CustomDateSettingInput,
    SpinnerWrapper,
    Spinner
};

export default theStyles;
